import { Button, InfiniteTable, Row } from "globalComponents";
import ExportCSV from "globalComponents/ExportCSV";
import { formatDollars } from "globalResources/helpers";
import React, { useEffect } from "react";
import { useState } from "react";
import moment from "moment";
import styled from "styled-components";
import axios from "axios";
import { errorHandler } from "globalResources/util";
import PositionModal from "pages/clients/components/PositionModal";

const Main = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.h3`
  font-weight: 600;
  font-size: 20px;
  margin: 0;
`;

const headers = [
  {
    label: "Client",
    render: (row) => <div>{row.client.name}</div>,
  },
  {
    label: "Position",
    render: (row) => <div>{row.name}</div>,
  },
  {
    label: "Bill Rate",
    render: (row) => (
      <div>
        ${formatDollars(row.billRate / 100)} ($
        {formatDollars(row.overtimeBillRate / 100)})
      </div>
    ),
  },
  {
    label: "Pay Rate",
    render: (row) => (
      <div>
        ${formatDollars(row.payRate / 100)} ($
        {formatDollars(row.overtimePayRate / 100)})
      </div>
    ),
  },
];

const UserPositions = ({ user }) => {
  const [selectedPosition, setSelectedPosition] = useState(null);
  const [positions, setPositions] = useState([]);

  const fetchPositions = async () => {
    try {
      const res = await axios.get("/positions", {
        params: { userId: user._id },
      });
      res.data.sort((a, b) => (a.user.firstName > b.user.firstName ? 1 : -1));
      setPositions(res.data);
    } catch (err) {
      const error = errorHandler(err);
    }
  };

  const format4CSV = () => {
    return positions.map((row) => ({
      UID: row.user.UID,
      externalId: row.user.externalId,
      EmployeeName: `${row.user.firstName} ${row.user.lastName}`,
      AddressLine1: row.user.addressLine1,
      AdderssLine2: row.user.addressLine2,
      State: row.user.state,
      Zipcode: row.user.zipcode,
      Position: row.name,
      accountType: row.user.accountType,
      TaxType: row.user.employeeType,
      BillRate: (row.billRate / 100).toFixed(2),
      PayRate: (row.payRate / 100).toFixed(2),
      ClientName: row.client.name,
      ClientAddress: `${row.client.address} ${row.client.city} ${row.client.state}, ${row.client.zipcode}`,
    }));
  };

  useEffect(() => {
    fetchPositions();
  }, [user]);

  return (
    <Main>
      <Row style={{ alignItems: "center", padding: "10px 0" }}>
        <Title>Positions ({positions.length})</Title>
        <Row style={{ marginLeft: "auto", alignItems: "center" }}>
          <ExportCSV
            label="Export Positions"
            data={format4CSV()}
            filename={`${
              user.firstName + " " + user.lastName
            }-positions-${moment().format("lll")}.csv`}
          />
        </Row>
      </Row>
      <InfiniteTable
        height="300px"
        data={positions}
        headers={headers}
        onClick={(row) => setSelectedPosition(row._id)}
      />
      {selectedPosition !== null && (
        <PositionModal
          id={selectedPosition}
          onClose={() => {
            setSelectedPosition(null);
            fetchPositions();
          }}
        />
      )}
    </Main>
  );
};
export default UserPositions;
